/* eslint-disable react/jsx-no-target-blank */
import React, { PureComponent, lazy, Suspense } from 'react';

import { Grid, Feedback } from '@icedesign/base';
import Layout from '@icedesign/layout';

import CustomizedMarker from 'react-project-customized-helper';
import { connect } from 'react-redux';

import cx from 'classnames';

import RequireDevice from '@/components/RequireDevice';
import DeviceTypes from '@/constants/DeviceTypes';
import { formatMessage } from '@/i18n';
import { getProfile } from '@/tool/profile';
import version from '@/version';

const FaChrome = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaChrome })));
const FaFirefox = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaFirefox })));
const FaSafari = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaSafari })));
const { Row } = Grid;
const DeviceRow = RequireDevice(Row);

class Footer extends PureComponent {
  render() {
    const { className, style, systemResult } = this.props;
    const linkProps = systemResult.appUrl ? { href: systemResult.appUrl, target: '_blank' } : {};
    // console.log(systemResult);

    // 获取当前域名
    const { hostname } = window.location;
    // 备案号映射
    const icpMap = {
      'vanmacloud.cn': '辽ICP备11019552号-24',
      'www.vanmacloud.cn': '辽ICP备11019552号-24',
      'vanmacloud.com': '辽ICP备11019552号-25',
      'www.vanmacloud.com': '辽ICP备11019552号-25',
    };
    // 获取备案号，默认''
    const icp = icpMap[hostname] || '';

    return (
      <Layout.Footer
        className={cx('ice-design-layout-footer', className)}
        style={{
          ...style,
          lineHeight: '36px',
        }}
      >
        <div className="ice-design-layout-footer-body">
          {/* <div style={{ filter: 'grayscale(100%)', opacity: 0.3 }}>
            <Logo />
          </div> */}
          <DeviceRow
            devices={[DeviceTypes.DESKTOP.TYPE, DeviceTypes.TABLET.TYPE]}
            unsupportDeviceView={<div />}
            align="center"
            className="recommended copyright"
          >
            {formatMessage('menu.footer.recommend.browser')}
            <Suspense fallback={null}>
              <FaChrome />
            </Suspense>
            &nbsp;&nbsp;
            <a
              href={formatMessage('menu.footer.recommend.browser.chrome')}
              target="_blank"
              className="copyright-link"
            >
              Chrome
            </a>
            、
            <Suspense fallback={null}>
              <FaFirefox />
            </Suspense>
            &nbsp;&nbsp;
            <a
              href={formatMessage('menu.footer.recommend.browser.firefox')}
              target="_blank"
              className="copyright-link"
            >
              FireFox
            </a>
            、
            <Suspense fallback={null}>
              <FaSafari />
            </Suspense>
            &nbsp;&nbsp;
            <a
              href={formatMessage('menu.footer.recommend.browser.safari')}
              target="_blank"
              className="copyright-link"
            >
              Safari
            </a>
          </DeviceRow>
          <div className="copyright">
            {/* 使用帮助：https://codeup.aliyun.com/5fad12cee89148238ce8082c/Common/react-project-customized-helper */}
            <CustomizedMarker
              type="console"
              // 非业务定制类title必须保证为空
              //               title='Project Name'
              //               // 从业务平台直接复制
              //               content={`
              // 1. content1
              // 2. content2
              // 3. content3
              //               `}
            />
            <span
              onDoubleClick={() => {
                const backendVersion = `V${getProfile().version}`;
                if (version.code !== backendVersion) {
                  Feedback.toast.prompt(`${version.code},${backendVersion}`);
                }
              }}
            >
              {version.code}
            </span>{' '}
            © {new Date().getFullYear()}{' '}
            {icp && (
              <>
                {'| '}
                <a
                  className="copyright-link"
                  rel="noopener noreferrer"
                  href="https://beian.miit.gov.cn/"
                  target="_blank"
                >
                  {icp}
                </a>
                {' | '}
              </>
            )}
            {!systemResult.customized ? 'developed & designed' : 'maintained'} by{' '}
            <a
              // TODO: 后期可考虑支持跳转官网
              className="copyright-link"
              rel="noopener noreferrer"
              {...linkProps}
            >
              {systemResult.appProducer}
            </a>
          </div>
        </div>
      </Layout.Footer>
    );
  }
}

function mapStateToProps(store) {
  return {
    systemResult: store.systemReducer,
  };
}

export default connect(mapStateToProps)(Footer);
